module.exports = __webpack_public_path__ + "static/img/project_1.108147c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainPage/project_1.jpg
// module id = IFD0
// module chunks = 0